import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { InferGetServerSidePropsType } from 'next';

import { wrapper } from '@store/store';

import { fetchHomepage } from '@api/homepage';

import Home from '@routes/Home/containers/Home';
import Error500 from '@routes/Error500';

import { fetchCMSComponentsData } from '@utils/fetchCMSComponentsData';
import { getRequestInstance } from '@utils/request';
import { getLocaleFromContext } from '@utils/getLocaleFromContext';

import { CmsComponentData, CmsComponentValue } from '@common/types/cms';

const HomePage = ({
  pageData,
  isError,
  componentsValue,
}: InferGetServerSidePropsType<typeof getServerSideProps>) =>
  isError ? (
    <Error500 />
  ) : (
    <Home
      pageData={pageData}
      componentsData={componentsValue}
    />
  );

export const getServerSideProps = wrapper.getServerSideProps(
  store => async context => {
    const request = getRequestInstance(context);
    let isError = false;
    let pageData;
    let componentsValue: (CmsComponentValue | null)[];

    try {
      pageData = await fetchHomepage(request);

      const componentsData = (await fetchCMSComponentsData(
        store.dispatch,
        pageData,
        request,
      )) as null | (CmsComponentData | null)[];

      if (!componentsData || !Array.isArray(componentsData)) {
        componentsValue = [];
      } else {
        componentsValue = componentsData
          .filter(data => !!(data && data.value))
          .map(data => data && data.value);
      }
    } catch {
      pageData = {};
      componentsValue = [];
      isError = true;
    }

    return {
      props: {
        ...(await serverSideTranslations(getLocaleFromContext(context))),
        pageData,
        componentsValue,
        isError,
      },
    };
  },
);

export default HomePage;
